module.exports = __webpack_public_path__ + "static/media/walletIcon.9e014e98.svg";